import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';

import { TipoServicoService } from '../services/tipo-servico.service';
import Swal from 'sweetalert2';

import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { AuthService } from '../services/auth.service';


@Component({
  selector: 'app-tipo-servico',
  templateUrl: './tipo-servico.component.html',
  styleUrls: ['./tipo-servico.component.css'],
  animations: [loadingFade, modal, alert]
})
export class TipoServicoComponent implements OnInit {
  public loading = false;
  public tipo_servicos = [];

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  	//acesso
	public menu_id = 126; //Cadastro - ADM
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	

  constructor(private fb: FormBuilder,
    private tipoServicoSvc: TipoServicoService,
    private route: ActivatedRoute,
		private perfilUsuarioSvc: PerfilUsuarioService,
		private authSvc: AuthService
    ) { }

  ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 


    this.loading = true;
    this.pegaTiposServico();
  }

  pegaTiposServico() {
    this.tipoServicoSvc.getTiposServico().then((data: any) => {
      this.tipo_servicos = data;
      this.count = this.tipo_servicos.length;
      this.loading = false;
    }).catch((err) => {
      this.loading = false;
      console.log(err);
    });
  }

  primPagina() {
    this.page = 1;
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
  }

  apagaTipoServico(id) {
    Swal.fire({
      type: 'warning',
      title: 'Deseja realmente apagar este registro?',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Apagar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33'

    }).then((result) => {
      if (result.value == true) {
        this.tipoServicoSvc.apagaTipoServico(id).then((data) => {
          this.pegaTiposServico();
          Swal.fire({
            type: 'success',
            title: 'Apagado com sucesso!'
          });
        }).catch((err) => {
          console.log(err);
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
          });
        });
      }
    })
  }

}
